import { render, staticRenderFns } from "./PolicyDetailGeneral.vue?vue&type=template&id=5b1dbec5&"
import script from "./PolicyDetailGeneral.vue?vue&type=script&lang=js&"
export * from "./PolicyDetailGeneral.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports